/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled, { css } from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../config/screen';

export const TrendingsDetailsContainer = styled.div`
  width: 100%;
  align-self: flex-end;
  justify-content: space-between;
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
`;

export const TrendingsLoadingContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MotorCurrentTextContainer = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
  width: max-content;
`;

export const ChartTrendingsTabContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TabsTrendingsContainer = styled.div`
  padding-bottom: 1.25rem;
  display: flex;
  justify-content: space-between;
`;

export const TrendingsHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const LastUpdateTime = styled.span`
  font-family: ${({ theme }) => theme.font.bold};
  color: ${({
    theme,
  }) => theme.color.crusherDashboard.trendings.lastUpdateStrongTextColor};
`;

export const LineChartContainer = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  min-height: 0;
  position: relative;
`;

export const ViewModeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    gap: 8px;
  }
`;

/* ****************** CUSTOM HEADER (mobile/tablet: replaces modal title) ****************** */

export const CustomHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  min-width: 0;
  max-width: 100%;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    gap: 16px;
  }
`;

/* Scrollable wrapper for the trending selector with fade edges */
interface ScrollableSelectorWrapperProps {
  showLeftFade: boolean;
  showRightFade: boolean;
}

export const ScrollableSelectorWrapper = styled.div<ScrollableSelectorWrapperProps>`
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1;
  min-width: 0;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ showLeftFade, showRightFade }) => {
    const hasBothFades: boolean = showLeftFade && showRightFade;
    const hasNoFade: boolean = !showLeftFade && !showRightFade;

    if (hasNoFade) {
      return css`mask-image: none;`;
    }

    if (hasBothFades) {
      return css`
        mask-image: linear-gradient(
          to right,
          transparent 0%,
          black 5%,
          black 95%,
          transparent 100%
        );
      `;
    }

    if (showLeftFade) {
      return css`
        mask-image: linear-gradient(
          to right,
          transparent 0%,
          black 5%,
          black 100%
        );
      `;
    }

    return css`
      mask-image: linear-gradient(
        to right,
        black 0%,
        black 95%,
        transparent 100%
      );
    `;
  }}

  /* Prevent the Ant Segmented from shrinking */
  > * {
    flex-shrink: 0;
  }
`;

/* Statistics selector - always visible, never scrolls */
export const StatisticsSelectorContainer = styled.div`
  flex-shrink: 0;
`;

/* ****************** RESPONSIVE LAYOUT (mobile/tablet md) ****************** */

export const TrendingsResponsiveRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 4px;
  padding-bottom: 0.25rem;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    gap: 8px;
    padding-bottom: 0.5rem;
  }
`;
